import { Navigate, Route, Routes } from 'react-router-dom'
import AuthStartPage from 'pages/auth/AuthStartPage'
import {
  LoginUrl,
  SamlLoginUrl,
  SignupUrl,
  SltLoginUrl,
  StartUrl
} from 'constants/RouteUrls'
import LoginPage from 'pages/auth/LoginPage'
import SamlCallbackPage from 'pages/auth/SamlCallbackPage'
import SltLoginPage from 'pages/auth/SltLoginPage'
import SignupPage from 'pages/auth/SignupPage'
import React from 'react'
import NotFoundPage from 'routes/NotFoundPage'

const cleanWildcard = (string: string) => {
  return string.replace('/auth/', '')
}

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={StartUrl} replace />} />
      <Route path={cleanWildcard(StartUrl)} element={<AuthStartPage />} />
      <Route path={cleanWildcard(LoginUrl)} element={<LoginPage />} />
      <Route
        path={cleanWildcard(SamlLoginUrl)}
        element={<SamlCallbackPage />}
      />
      <Route path={cleanWildcard(SltLoginUrl)} element={<SltLoginPage />} />
      <Route
        path={`${cleanWildcard(SignupUrl)}/:type?`}
        element={<SignupPage />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default AuthRoutes
